"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _sizes = require("@decisiv/design-tokens/lib/iconography/sizes");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var SvgCoffeeHot32 = function SvgCoffeeHot32(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'medium' : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutProperties(_ref, ["size", "color"]);

  return _react.default.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    fill: "none",
    width: _sizes.alias[size],
    height: _sizes.alias[size],
    color: color,
    focusable: "false"
  }, props), _react.default.createElement("path", {
    d: "M14.8 4.001a7.181 7.181 0 00-.934-3.503l-.012-.02-.004-.007-.002-.002-.002-.003-.845.534.845-.534a1 1 0 00-1.694 1.064l2.185-.03-2.183.032.014.024a4.943 4.943 0 01.296.645 5.18 5.18 0 01.337 1.8 5.172 5.172 0 01-.647 2.467l-.001.002a1 1 0 001.693 1.064l-.81-.511.81.51h.002l.001-.004.005-.007.012-.02a3.478 3.478 0 00.149-.27A7.172 7.172 0 0014.8 4zM20.607 17.168a1 1 0 00-1.966-.367l-1.124 6.015a1 1 0 001.966.368l1.124-6.016z",
    fill: "currentColor"
  }), _react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 12a1 1 0 00-.98 1.198l2.833 14a1 1 0 00.98.802h11.334a1 1 0 00.98-.802l.85-4.198H25a5 5 0 005-5v-1a5 5 0 00-5-5H7zm18 9h-1.599l1.417-7H25a3 3 0 013 3v1a3 3 0 01-3 3zm-14.349 5L8.223 14h14.554L20.35 26H10.65z",
    fill: "currentColor"
  }), _react.default.createElement("path", {
    d: "M4 30a1 1 0 100 2h24a1 1 0 100-2H4zM16.464 4.5A7.181 7.181 0 0016 7a7.172 7.172 0 00.935 3.502l.012.02.005.006.001.003.001.001.81-.51-.81.511a1 1 0 001.694-1.064l-.001-.002a4.904 4.904 0 01-.31-.669A5.172 5.172 0 0118 7.001a5.18 5.18 0 01.647-2.47L16.464 4.5z",
    fill: "currentColor"
  }), _react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.954 3.466l-.001.003-.002.002-.004.007-.012.02a3.497 3.497 0 00-.15.27c-.09.175-.206.424-.321.732l2.184.03a1 1 0 00-1.694-1.064zm0 0L17.8 4l-.846-.534z",
    fill: "currentColor"
  }));
};

SvgCoffeeHot32.propTypes = {
  size: _propTypes.default.oneOf(Object.keys(_sizes.alias)),
  color: _propTypes.default.string
};
var _default = SvgCoffeeHot32;
exports.default = _default;